import React from 'react';
import PropTypes from 'prop-types';

import SelectInput from 'components/shared/SelectInput.react';

const frequencyOptions = [
  { value: 'weekly', label: 'Weekly' },
  { value: 'fortnightly', label: 'Fortnightly' },
  { value: 'monthly', label: 'Monthly' },
  { value: 'every-2-months', label: 'Every 2 months' },
  { value: 'every-3-months', label: 'Every 3 months' },
  { value: 'every-6-months', label: 'Every 6 months' },
  { value: 'yearly', label: 'Yearly' },
];

const FrequencySelect = ({ selectedValue, onChange, ...other }) => {
  return (
    <SelectInput
      selectedValue={selectedValue}
      onChange={onChange}
      options={frequencyOptions}
      label="Frequency"
      {...other}
    />
  );
};

FrequencySelect.propTypes = {
  selectedValue: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default FrequencySelect;
